























































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import {
  required,
  maxLength,
  minLength,
  minValue,
  numeric,
} from "vuelidate/lib/validators";

import LanguagesBtns from "@/components/app/shared/btn&dd/languages-btns.vue";
import StandartModal from "@/components/app/standart-modal.vue";

import type {
  ComplexMenuVariant,
  ComplexMenuItemAdd,
} from "@/@types/menu/complex-menu";
import type { Locale, LanguageCode } from "@/@types/_shared/locale";

@Component({
  components: {
    StandartModal,
    LanguagesBtns,
  },
  mixins: [validationMixin],
  validations: {
    name: { required, minLength: minLength(1), maxLength: maxLength(100) },
    calorie: { numeric, minValue: minValue(0) },
    proteins: { numeric, minValue: minValue(0) },
    fats: { numeric, minValue: minValue(0) },
    carbohydrates: { numeric, minValue: minValue(0) },
  },
})
class AddComplexMenuVariantModal extends Vue {
  @Prop({ type: Object, default: null }) item!: ComplexMenuVariant | null;
  @Prop({ type: String, default: "" }) shopId!: string;

  defaultLocale: LanguageCode = this.$store.getters.getLanguages
    ? this.$store.getters.getLanguages[0]
    : "ru";
  currentLocale: LanguageCode = this.defaultLocale;

  // Current dish being added
  name = "";
  names: Locale = {};
  calorie: number | null = null;
  proteins: number | null = null;
  fats: number | null = null;
  carbohydrates: number | null = null;
  weight: number | null = null;

  // Dishes in variant
  dishes: ComplexMenuItemAdd[] = [];

  // Table fields
  get dishFields() {
    return [
      { key: "index", label: "#", class: "text-center" },
      { key: "name", label: this.$t("complex-menu.fields.name.label") },
      { key: "calorie", label: this.$t("complex-menu.fields.calorie.label") },
      { key: "proteins", label: this.$t("complex-menu.fields.proteins.label") },
      { key: "fats", label: this.$t("complex-menu.fields.fats.label") },
      {
        key: "carbohydrates",
        label: this.$t("complex-menu.fields.carbohydrates.label"),
      },
      { key: "actions", label: "", class: "text-center" },
    ];
  }

  // Computed properties
  get isCurrentDishValid(): boolean {
    return !this.$v.$invalid;
  }

  get isFormInvalid(): boolean {
    return this.dishes.length === 0;
  }

  get totalNutrition() {
    return this.dishes.reduce(
      (acc, dish) => ({
        calorie: acc.calorie + (dish.calorie || 0),
        proteins: acc.proteins + (dish.proteins || 0),
        fats: acc.fats + (dish.fats || 0),
        carbohydrates: acc.carbohydrates + (dish.carbohydrates || 0),
      }),
      { calorie: 0, proteins: 0, fats: 0, carbohydrates: 0 }
    );
  }

  get variant(): ComplexMenuVariant {
    return {
      _id: this.item?._id || "",
      variant: this.item?.variant || undefined,
      menu_ids: [],
      menu: this.dishes as any,
    };
  }

  // Methods
  addDishToVariant() {
    if (!this.isCurrentDishValid) return;

    // Save name for current locale
    this.$set(this.names, this.currentLocale, this.name);

    const newDish: Partial<ComplexMenuItemAdd> = {
      name: { ...this.names } as any,
      calorie: this.calorie || 0,
      proteins: this.proteins || 0,
      fats: this.fats || 0,
      carbohydrates: this.carbohydrates || 0,
    };

    this.dishes.push(newDish as any);
    this.resetCurrentDish();
    this.$v.$reset();
  }

  removeDish(index: number) {
    this.dishes.splice(index, 1);
  }

  resetCurrentDish() {
    this.name = "";
    this.names = {};
    this.calorie = null;
    this.proteins = null;
    this.fats = null;
    this.carbohydrates = null;
    this.weight = null;
  }

  onSubmit(e: Event) {
    e.preventDefault();

    if (this.dishes.length === 0) return;

    this.$emit("setVariant", this.variant);
    this.$bvModal.hide("add-complex-menu-variant");
  }

  @Watch("name")
  changeName() {
    this.$set(this.names, this.currentLocale, this.name);
  }

  @Watch("currentLocale")
  changeLocale() {
    this.name = this.names[this.currentLocale] || "";
  }

  @Watch("item")
  createFields() {
    if (!this.item) return;
    this.dishes = this.item.menu ? [...this.item.menu] : [];
  }

  isClean() {
    this.dishes = [];
    this.resetCurrentDish();
    this.$v.$reset();
  }
}

export default AddComplexMenuVariantModal;
